export function StatusCellRenderer(props) {
  const colors = {
    success: "#28A745",
    secondary: "#6C757D",
    primary: "#007BFF",
    danger: "#DC3545",
    warning: "#FFC107",
    info: "#17A2B8",
    light: "#F8F9FA",
    dark: "#343A40",
  };
  function hexToRgba(hex, opacity) {
    hex = colors[hex]?.replace("#", "");
    var r = parseInt(hex?.substring(0, 2), 16);
    var g = parseInt(hex?.substring(2, 4), 16);
    var b = parseInt(hex?.substring(4, 6), 16);

    return {
      color: hex,
      backgroundColor: `rgba(${r},${g},${b},${opacity})`,
      borderColor: `rgba(${r},${g},${b},0.5)`,
    };
  }
  try {
    if (props.data && props.value !== "") {
      const celldata = props.colDef?.options;
      const stat = celldata?.find((item) => {
        return (item?._id || item?.id) === props?.data[props?.colDef?.field];
      });
      if (stat) {
        return (
          <span
            className={`status-text status_label_details`}
            style={{
              backgroundColor: hexToRgba(stat?.color, 0.1).backgroundColor,
              color: "#" + hexToRgba(stat?.color, 0.1).color,
              border: `1px solid ${hexToRgba(stat?.color, 0.1).borderColor}`,
            }}
          >
            {" "}
            {stat?.name}
          </span>
        );
      }
    } else {
      const groupval = props.value;
      const options = props?.node?.rowGroupColumn?.colDef?.options;
      if (options !== undefined && Array.isArray(options)) {
        return options?.find((itt) => (itt._id || itt.id) === groupval)?.name;
      } else {
        return;
      }
    }
  } catch (error) {
    console.log(error.message);
  }
}
